import { baseUrl, buildQueryParams } from "./Requests.js";

const defaultOptions = {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
  },
  credentials: "include",
};

function requestGuruInfo(path, query = {}) {
  const params = buildQueryParams(query);
  const queryString = params.toString();
  const url = queryString ? `${baseUrl}/${path}?${queryString}` : `${baseUrl}/${path}`;
  return fetch(url, defaultOptions);
}

async function getDashboard(category) {
  const normalizedCategory = typeof category === "string"
    ? category.toUpperCase()
    : category;
  const params = buildQueryParams({ "category": normalizedCategory });
  const response = await fetch(
    `${baseUrl}/dashboard?${params.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
  
  return response.json();
}

async function getPortfolio(guruid) {
  const normalizedGuruId = typeof guruid === "string"
    ? Number(guruid)
    : guruid;

  const params = buildQueryParams({ "guruid": normalizedGuruId });
  const response = await fetch(
    `${baseUrl}/mirror_portfolio?${params.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
  
  return response;

}

function getGuruHistoryByTickerInfo(ticker) {
  return requestGuruInfo("guru_history_by_ticker", { ticker });
}

const normalizeGuruHistory = (raw) => {
  if (!raw) return null;

  const normalizeEntry = (entry) => {
    if (!entry || entry.guru) return entry;
    return {
      ...entry,
      guru: {
        guruid: entry.guruid ?? entry.id ?? null,
        nickname: entry.nickname,
        leader: entry.leader,
        institution: entry.institution,
        percent: entry.percent,
        imagefile: entry.imagefile,
      },
    };
  };

  const ensureArray = (bucket) => {
    if (!bucket) return [];
    if (Array.isArray(bucket)) return bucket.map(normalizeEntry);
    if (typeof bucket === "object") return Object.values(bucket).map(normalizeEntry);
    return [];
  };

  const hasBuckets = (value) => value && (value.buy || value.sell || value.unknown);

  const items = Array.isArray(raw?.items)
    ? raw.items
    : Array.isArray(raw?.data)
      ? raw.data
      : Array.isArray(raw)
        ? raw
        : null;

  if (items) {
    const grouped = {};
    items.forEach((item) => {
      if (!item) return;
      const categoryKey = String(item.category || "UNKNOWN").toUpperCase();
      const bucketKey = String(item.bucket || "unknown").toLowerCase();

      if (!grouped[categoryKey]) {
        grouped[categoryKey] = { buy: [], sell: [], unknown: [] };
      }
      if (!grouped[categoryKey][bucketKey]) {
        grouped[categoryKey][bucketKey] = [];
      }
      grouped[categoryKey][bucketKey].push(normalizeEntry(item));
    });

    Object.values(grouped).forEach((category) => {
      Object.keys(category).forEach((bucket) => {
        category[bucket].sort((a, b) => {
          const aRank = Number(a?.rank ?? a?.guru?.rank);
          const bRank = Number(b?.rank ?? b?.guru?.rank);
          if (Number.isFinite(aRank) && Number.isFinite(bRank)) return aRank - bRank;
          if (Number.isFinite(aRank)) return -1;
          if (Number.isFinite(bRank)) return 1;
          return 0;
        });
      });
    });

    return grouped;
  }

  if (typeof raw === "object") {
    const normalized = {};
    Object.keys(raw).forEach((categoryKey) => {
      const category = raw[categoryKey];
      if (!hasBuckets(category)) return;

      normalized[categoryKey.toUpperCase()] = {
        buy: ensureArray(category.buy),
        sell: ensureArray(category.sell),
        unknown: ensureArray(category.unknown),
      };
    });

    return Object.keys(normalized).length ? normalized : raw;
  }

  return raw;
};

export { getGuruHistoryByTickerInfo, getPortfolio, getDashboard, normalizeGuruHistory };
